// extracted by mini-css-extract-plugin
export default {"livroCard":"livroCard_livroCard__pVOkR","livroCardContainer":"livroCard_livroCardContainer__d0yHE","Link":"livroCard_Link__A3Sjb"};